import React from 'react'

const LoginPage = () => {
  return <h1>Login</h1>
}

export default LoginPage
